import React from 'react';
import { Route } from 'react-router-dom';
import IActions from 'app/types/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as onBoardingActions from 'app/ducks/onboarding/actions';
import * as organisationActions from 'app/ducks/organisations/actions';
import * as competitionActions from 'app/ducks/competitions/actions';
import * as groupsActions from 'app/ducks/groups/actions';
import * as organisationSectionActions from 'app/ducks/organisationSections/actions';
import * as connectActions from 'app/ducks/connect/actions';
import * as teamsActions from 'app/ducks/teams/actions';
import * as teamConnectionActions from 'app/ducks/teamConnections/actions';

import * as onBoardingSelectors from 'app/ducks/onboarding/selectors';
import * as organisationSelectors from 'app/ducks/organisations/selectors';
import * as competitionSelectors from 'app/ducks/competitions/selectors';
import * as groupsSelectors from 'app/ducks/groups/selectors';
import * as teamsSelectors from 'app/ducks/teams/selectors';
import * as organisationSectionSelectors from 'app/ducks/organisationSections/selectors';

import HeaderCenter from 'app/components/layout/HeaderCenter';
import TeamDetails from './components/TeamDetails';
import ClubDetails from './components/ClubDetails';
import ConnectDetails from './components/ConnectDetails';
import PersonalDetails from './components/PersonalDetails';
import VerifyEmail from './components/VerifyEmail';
import TeamShare from './components/TeamShare';
import BankDetails from './components/BankDetails';

interface IOnboardingLayoutProps {
  awaitingUserVerification: boolean;
  createUserAndTeam: any;
  hasUserCreated: boolean;
  hasUserLoggedIn: boolean;
  continueToDashboard: boolean;
  history: any;
  isLoading: boolean;
  loginCurrentUser: any;
  match: {
    url: string;
    params: any;
  };
  newUser: {
    email: string;
    password: string;
    team: any;
    fullName: string;
  };
  verificationSuccessful: boolean;
  onBoarding: any;
  teams: any;
  organisations: any;
  organisationSections: any;
  groups: any;
  actions: IActions;
}

function selector(state): any {
  return {
    onBoarding: {
      ...onBoardingSelectors.getOnBoarding(state),
      teamShareUrl: onBoardingSelectors.getShareUrl(state),
    },
    organisations: {
      ...organisationSelectors.getOrganisations(state),
    },
    competitions: {
      ...competitionSelectors.getCompetitions(state),
    },
    connect: state.connect,
    groups: groupsSelectors.getGroups(state),
    teams: teamsSelectors.getTeams(state),
    organisationSections: organisationSectionSelectors.getOrganisationSections(
      state,
    ),
  };
}

const actionCreators = _.merge(
  onBoardingActions,
  organisationActions,
  groupsActions,
  organisationSectionActions,
  connectActions,
  teamsActions,
  competitionActions,
  teamConnectionActions,
);

@(connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
})) as any)
export default class OnboardingLayout extends React.Component<
IOnboardingLayoutProps,
{}
> {
  static defaultProps: IOnboardingLayoutProps = {
    awaitingUserVerification: undefined,
    createUserAndTeam: undefined,
    hasUserCreated: undefined,
    hasUserLoggedIn: undefined,
    continueToDashboard: undefined,
    history: undefined,
    isLoading: undefined,
    loginCurrentUser: undefined,
    match: undefined,
    newUser: undefined,
    verificationSuccessful: undefined,
    onBoarding: undefined,
    teams: undefined,
    actions: undefined,
    organisations: undefined,
    organisationSections: undefined,
    groups: undefined,
  };

  checkRoute = ({
    awaitingUserVerification,
    match,
    verificationSuccessful,
    hasUserCreated,
    continueToDashboard,
    history,
  }): void => {
    if (
      awaitingUserVerification
      && history.location.pathname !== `${match.url}/verify`
    ) {
      history.push(`${match.url}/verify`);
    } else if (
      verificationSuccessful
      && history.location.pathname !== `${match.url}/share`
      && history.location.pathname !== `${match.url}/account`
      && history.location.pathname !== `${match.url}/connect`
    ) {
      history.push(`${match.url}/connect`);
    }
    if (
      hasUserCreated
      && continueToDashboard
      && history.location.pathname !== 'my-dashboard'
    ) {
      history.push('/dashboard');
    }
  };

  render(): React.ReactNode {
    this.checkRoute(this.props);
    return (
      <div className="container on-boarding-app login-app m-h-100">
        <div className="row">
          <div className="col">
            <HeaderCenter />
            <div className="row justify-content-center">
              <div className="col-sm-10 col-md-8 col-lg-6">
                <Route
                  exact
                  path="/get-started"
                  render={() => (
                    <TeamDetails
                      {...this.props}
                      {...this.props.onBoarding}
                      {...this.props.onBoarding.inFlightUser}
                    />
                  )}
                />
                <Route
                  exact
                  path="/get-started/club"
                  render={() => (
                    <ClubDetails
                      {...this.props}
                      {...this.props.onBoarding}
                      {...this.props.onBoarding.inFlightUser}
                    />
                  )}
                />
                <Route
                  exact
                  path="/get-started/connect/:orgConnectionCode"
                  render={() => (
                    <TeamDetails
                      {...this.props}
                      {...this.props.onBoarding}
                      {...this.props.onBoarding.inFlightUser}
                    />
                  )}
                />
                <Route
                  exact
                  path="/get-started/personal"
                  render={() => (
                    <PersonalDetails
                      {...this.props}
                      {...this.props.onBoarding}
                      {...this.props.onBoarding.inFlightUser}
                    />
                  )}
                />
                <Route
                  exact
                  path="/get-started/verify"
                  render={() => (
                    <VerifyEmail
                      email={this.props.onBoarding?.inFlightUser?.email}
                      backendErrors={this.props.onBoarding.backendErrors}
                      isLoading={this.props.onBoarding.isLoading}
                      location={this.props.location}
                      verifyUser={this.props.actions.verifyUser}
                    />
                  )}
                />
                <Route
                  exact
                  path="/get-started/connect"
                  render={() => (
                    <ConnectDetails
                      {...this.props}
                      organisations={this.props.organisations}
                      competitions={this.props.competitions}
                      organisationSections={this.props.organisationSections}
                      handleConnect={this.props.actions.updateConnect}
                      groups={this.props.groups}
                      {...this.props.onBoarding}
                      {...this.props.onBoarding.inFlightUser}
                    />
                  )}
                />
                <Route
                  exact
                  path="/get-started/share"
                  render={() => (
                    <TeamShare
                      {...this.props}
                      {...this.props.onBoarding}
                      {...this.props.onBoarding.inFlightUser}
                    />
                  )}
                />
                <Route
                  exact
                  path="/get-started/account"
                  render={() => (
                    <BankDetails
                      {...this.props}
                      {...this.props.actions}
                      {...this.props.onBoarding}
                      {...this.props.onBoarding.inFlightUser}
                    />
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
